var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full"},[(_vm.islogin)?_c('login',{attrs:{"subject_code":_vm.subject_code}}):_vm._e(),(_vm.isindex)?_c('index'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }